import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, XCircle } from "lucide-react";
import { useI18n } from "../lib/i18n";
import { FadeIn } from "../components/Reveal";
import SEO from "../components/SEO";

export default function Verified() {
  const { d } = useI18n();
  const v = d.verify;
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");

  useEffect(() => {
    const token = params.get("token");
    if (!token) {
      setState("error");
      return;
    }
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/submissions/verify-email`, { params: { token } })
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [params]);

  return (
    <main className="flex min-h-[70vh] flex-col justify-center pt-24" data-testid="verify-page">
      <SEO page="home" noindex />
      <div className="mx-auto max-w-xl px-6 text-center">
        {state === "checking" && (
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground" data-testid="verify-checking">{v.checking}</p>
        )}
        {state === "ok" && (
          <FadeIn>
            <CheckCircle2 size={44} className="mx-auto text-foliage dark:text-stalk" />
            <h1 className="mt-6 font-serif text-3xl" data-testid="verify-success-title">{v.okTitle}</h1>
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{v.okText}</p>
          </FadeIn>
        )}
        {state === "error" && (
          <FadeIn>
            <XCircle size={44} className="mx-auto text-crimson dark:text-stalk" />
            <h1 className="mt-6 font-serif text-3xl" data-testid="verify-error-title">{v.errTitle}</h1>
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground">{v.errText}</p>
          </FadeIn>
        )}
        {state !== "checking" && (
          <Link to="/" data-testid="verify-home-link" className="u-link mt-8 inline-block font-mono text-xs uppercase tracking-[0.25em] text-crimson dark:text-stalk">
            {v.home}
          </Link>
        )}
      </div>
    </main>
  );
}
